import Cookies from "js-cookie";

export default {
  setItem (key, item) {
    Cookies.set(key, item, { expires: 7 });
  },

  getItem (key) {
    return Cookies.get(key);
  },

  removeItem (key) {
    Cookies.remove(key);
  },

  clear () {
    // not supported
  }
};
